<template>
  <div>
    <base-loading v-if="loading.filter" />
    <v-row v-else align="center" justify="center" class="px-10">
      <v-col class="pa-1" cols="2" sm="2" md="2">
        <v-menu
          v-model="menuDataIni"
          :close-on-content-click="false"
          :nudge-right="40"
          transition="scale-transition"
          offset-y
          min-width="290px"
        >
          <template v-slot:activator="{ on }">
            <v-text-field
              :value="moment(form.dataInicio).format('DD/MM/YYYY')"
              label="Data Inicial"
              prepend-icon="mdi-calendar"
              color="teal"
              readonly
              v-on="on"
            />
          </template>
          <v-date-picker
            v-model="form.dataInicio"
            style="margin: 0px"
            color="teal"
            locale="pt-br"
            @input="menuDataIni = false"
          />
        </v-menu>
      </v-col>
      <v-col class="pa-1" cols="2" sm="2" md="2">
        <v-menu
          v-model="menuDataFim"
          :close-on-content-click="false"
          :nudge-right="40"
          transition="scale-transition"
          offset-y
          min-width="290px"
        >
          <template v-slot:activator="{ on }">
            <v-text-field
              :value="moment(form.dataFim).format('DD/MM/YYYY')"
              color="teal"
              label="Data Final"
              prepend-icon="mdi-calendar"
              readonly
              v-on="on"
            />
          </template>
          <v-date-picker
            v-model="form.dataFim"
            :min="form.dataInicio"
            :max="dataLimite"
            color="teal"
            locale="pt-br"
            @input="menuDataFim = false"
          />
        </v-menu>
      </v-col>
      <v-col cols="3">
        <v-autocomplete
          v-model="form.consultor"
          autocomplete="autocomplete_off_hack_xfr4!k"
          label="Consultor"
          :items="consultores"
          item-text="Nome"
          item-value="id"
          clearable
          :disabled="loading.consultor"
          :loading="loading.consultor"
          required
          @change="selectConsultor()"
        />
      </v-col>
      <v-col cols="3">
        <v-autocomplete
          v-model="form.supervisor"
          autocomplete="autocomplete_off_hack_xfr4!k"
          label="Supervisor"
          :items="supervisores"
          item-text="Nome"
          item-value="id"
          clearable
          :disabled="loading.supervisor"
          :loading="loading.supervisor"
          required
          @change="selectSupervisor()"
        />
      </v-col>

      <v-col class="pa-2" cols="2" sm="2" md="2">
        <v-row justify="end" align="center">
          <v-btn
            style="color: white; border-radius: 8px; margin-left: 40%"
            color="green darken-1"
            :disabled="!form.consultor && !form.supervisor"
            @click="search"
          >
            <span style="font-size: 16px; font-weight: 600">Buscar</span>
          </v-btn>
        </v-row>
      </v-col>
    </v-row>
  </div>
</template>

<script>
import consultantService from '../../../services/api/consultant'
import supervisorService from '../../../services/api/supervisor'

export default {
  name: 'VisitFilter',

  props: {
    userId: {
      type: String,
      default: null,
    },
  },

  data() {
    return {
      loading: {
        filter: false,
        consultor: true,
        supervisor: true,
      },

      searching: true,
      dataLimite: this.moment(this.dataInicio).add(0, 'months').toISOString(),
      menuDataIni: false,
      menuDataFim: false,

      form: {
        user: null,
        consultor: null,
        supervisor: null,
        name: null,
        dataInicio: this.moment()
          .subtract(1, 'months')
          .toISOString(true)
          .substr(0, 10),
        dataFim: this.moment().toISOString(true).substr(0, 10),
      },

      consultores: [{ Nome: 'Carregando', id: 0 }],
      supervisores: [{ Nome: 'Carregando', id: 0 }],
    }
  },

  created() {
    this.loadConsultores()
    this.loadSupervisores()
  },

  methods: {
    async loadConsultores() {
      this.loading.consultor = true

      this.consultores = await consultantService.list(1, true)

      this.loading.consultor = false

      if (this.userId) {
        this.form.consultor = this.userId
        this.form.dataInicio = this.moment()
          .startOf('year')
          .toISOString(true)
          .substr(0, 10)
        this.search()
      }
    },

    async loadSupervisores() {
      this.loading.supervisor = true
      this.supervisores = await supervisorService.getSupervisores(1, true)
      this.loading.supervisor = false
    },

    selectConsultor() {
      this.form.supervisor = null
    },
    selectSupervisor() {
      this.form.consultor = null
    },

    search() {
      if (!this.form.consultor && !this.form.supervisor) {
        return this.Toast().fire({
          icon: 'warning',
          title: 'Selecione um consultor ou supervisor',
        })
      }

      if (this.form.consultor) {
        this.form.user = this.consultores.find(
          consultor => consultor.id === this.form.consultor,
        )
      } else {
        this.form.user = this.supervisores.find(
          supervisor => supervisor.id === this.form.supervisor,
        )
      }

      this.$emit('search', this.form)
    },
  },
}
</script>
